import React, { FC, useEffect, useState } from "react"
import { Navigate, useSearchParams } from "react-router-dom"
import { useAppDispatch, useAuth as useAppAuth } from "@app/hooks"
import { useAuth as useOIDCAuth } from "react-oidc-context"
import { resetAuth, getAuthType, isOIDCAuth } from "../../store"
import { useAppSelector } from "@app/hooks"
import { CircularProgress, Box, Typography } from "@mui/material"

interface ILogoutProps {}

export const LogoutPage: FC<ILogoutProps> = (props) => {
  const dispatch = useAppDispatch()
  const appAuth = useAppAuth()
  const oidcAuth = useOIDCAuth()
  const authType = useAppSelector(getAuthType)
  const isOIDC = useAppSelector(isOIDCAuth)
  const [isLoggingOut, setIsLoggingOut] = useState(true)
  const [searchParams] = useSearchParams()

  useEffect(() => {
    const performLogout = async () => {
      try {
        // Проверяем, вернулись ли мы с Keycloak logout
        const isFromKeycloak =
          searchParams.has("state") ||
          searchParams.has("session_state") ||
          !oidcAuth.isAuthenticated

        if (isFromKeycloak || !isOIDC) {
          // Мы вернулись с Keycloak logout или это стандартный logout
          dispatch(resetAuth())
          setIsLoggingOut(false)
        } else if (isOIDC && oidcAuth.isAuthenticated) {
          // Инициируем OIDC logout - переход на Keycloak
          await oidcAuth.signoutRedirect()
          // После этого Keycloak редиректит обратно на /logout
        }
      } catch (error) {
        console.error("Logout error:", error)
        // В случае ошибки всё равно сбрасываем локальное состояние
        dispatch(resetAuth())
        setIsLoggingOut(false)
      }
    }

    performLogout()
  }, [dispatch, isOIDC, oidcAuth, searchParams])

  // Показываем загрузку во время процесса logout
  if (isLoggingOut) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        minHeight="50vh"
        gap={2}
      >
        <CircularProgress />
        <Typography variant="body1">Выходим из системы...</Typography>
      </Box>
    )
  }

  // После завершения logout перенаправляем на главную
  return <Navigate to="/" replace />
}
